// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import PreviewDocumentModal from './data'

export default function PreviewDocumentModalFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/PreviewDocumentModal">
      <PreviewDocumentModal {...props}>
        {children}
      </PreviewDocumentModal>
    </Flow>
  )
}
